module.exports = __webpack_public_path__ + "media/images/career_camp/2023/areas_1-9b1a40c40478bad011e4b7f1ff3146ac.png";